<template>


<TopBar />

<div class="main-container">

<SideBar />

<div class="main"> 


<section>

<div class="container" style="border-bottom: solid 1px #f0f0f0; padding-top: 10px; padding-bottom: 10px;">


<div class="row">

<div class="col-md-6 pt-3">
<h3> <i class="bi bi-bar-chart color-1"></i> Weather Trends</h3>
</div>



</div>

</div>

</section>


<section style="padding-top:200px;" v-if="show_spinner==true">

<div style="text-align:center;">

<h6 class="text-secondary">Please wait...</h6>
<div class="spinner-border  text-info"></div>
</div>

</section>


<section v-if="show_spinner==false && all_data.length>0 ">
  
<div class="container">

    <div class="row">

    <div class="col-md-12">

      <div>


        <div class="row">

           <div class="col-md-4" style="padding-top:20px;">
          <button @click="get_filter_month(current_month())" style="margin-right:10px;" class="btn btn-1"> <i class="bi bi-calendar-week"></i> This month</button>
            <button @click="get_filter_month(last_month())" class="btn btn-1"> <i class="bi bi-calendar-week"></i> Last month</button> Or Filter:
        </div>


        <div class="col-md-4"  style="padding-top:20px;">
          <select v-model="filter_month" class="form-control" @change="get_filter_month(filter_month)">
            <option>January</option>
            <option >February</option>
            <option>March</option>
            <option>April</option>
            <option>May</option>
            <option>June</option>
            <option>July</option>
            <option>August</option>
            <option>September</option>
            <option>October</option>
            <option>November</option>
            <option>December</option>
          </select>
        </div>


        <div class="col-md-4" style="padding-top:20px; text-align: right;">
          <button @click="export_excel()" class="btn btn-1"> <i class="bi bi-file-spreadsheet"></i> Export Excel</button>
        </div>
          
        </div>

       

      

      <div class="row">

        <div class="col-md-6">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
          Average Temperatures( <sup>o</sup>C )
        </h6>


        <CanvasJSChart :options="options" />

       </div> 

        </div>


         <div class="col-md-6">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
          Average Humidity( % )
        </h6>


        <CanvasJSChart :options="humidity_data" />

       </div> 

        </div>


         <div class="col-md-6">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
          Average Pressure( hPa )
        </h6>


        <CanvasJSChart :options="pressure_data" />

       </div> 

        </div>



         <div class="col-md-6">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
          Wind Speed( m/s )
        </h6>


        <CanvasJSChart :options="wind_data" />

       </div> 

        </div>



         <div class="col-md-6">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
          Light Inensity( lux )
        </h6>


        <CanvasJSChart :options="light_data" />

       </div> 

        </div>



         <div class="col-md-6">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
          Rain( mm )
        </h6>


        <CanvasJSChart :options="rain_data" />

       </div> 

        </div>




          <div class="col-md-6">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
          UV Index( uvi )
        </h6>


        <CanvasJSChart :options="uv_data" />

       </div> 

        </div>





        
      </div> 

      

        
      </div>
      
    </div>
    
  </div>

  
  
  
</div>

</section>




</div>




</div>




<Footer />

</template>



<script>

import Header from './layouts/Header'
import SideBar from './layouts/SideBar'
import TopBar from './layouts/TopBar'
import Footer from './layouts/Footer'
import axios from 'axios'

import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'


export default{
name : 'home',
components : { Header, SideBar, TopBar, Footer,  },
data(){
return{
show_spinner : true,
today_data : [],
all_data : [],

chart : null,
options: {},
humidity_data : {},
pressure_data : {},
wind_data : {},
light_data : {},
rain_data : {},
uv_data : {},
filter_month : '',
filtered_data : []
}
},

methods : {

  export_excel() {
  // Step 1: Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(this.filtered_data)

  // Step 2: Create a workbook and add the worksheet
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

  // Step 3: Write the file and trigger download
  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  })

  const blob = new Blob([excelBuffer], {
    type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  saveAs(blob, 'weather-data.xlsx')
},



  get_filter_month(filter_month){

    this.filter_month = filter_month

    this.get_data()

  },

  date_to_words(date_time){
const date = new Date(date_time);

const formatted = date.toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
});

return formatted
  },

  convert_to_date_only(date_time){
const dt = new Date(date_time)
const dateOnly = dt.toISOString().split('T')[0]
return dateOnly
},

last_month() {
  const currentDate = new Date();
  const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
  const monthName = lastMonthDate.toLocaleString('default', { month: 'long' });
  return monthName;
},


  current_month(){
    const currentDate = new Date();
const monthName = currentDate.toLocaleString('default', { month: 'long' });
return monthName
},

   current_year(){
    const currentDate = new Date();
const year = currentDate.getFullYear();
return year
  },

  convert_to_year_only(date_time){
    const currentDate = new Date(date_time);
const year = currentDate.getFullYear();
return year
  },

  convert_to_month_only(date_time){
    const currentDate = new Date(date_time);
const monthName = currentDate.toLocaleString('default', { month: 'long' });
return monthName
},

async get_data() {
  this.show_spinner = true
  /*
  setTimeout((data)=>{
this.show_spinner = false
}, 5000)

*/


try {
const response = await axios.get('https://weather-data-marsabit-default-rtdb.firebaseio.com/.json')
const dataObject = response.data.weather_data
const dataArray = Object.values(dataObject)
const today_raw_data = dataArray
const all_data = dataArray

this.all_data = all_data
let temp_data = []
let humidity_temp_data = []
let pressure_temp_data = []
let wind_temp_data = []
let light_temp_data = []
let rain_temp_data = []
let uv_temp_data = []
let all_temp_data = []

//get filtered data  
today_raw_data.forEach((data)=>{

let month = this.convert_to_month_only(data.received_at)
let year = this.convert_to_year_only(data.received_at)


if(month==this.filter_month && year==this.current_year()){

if(data.uplink_message.decoded_payload){

data.uplink_message.decoded_payload.date = data.received_at

all_temp_data = all_temp_data.concat(data.uplink_message.decoded_payload)





//console.log(data.uplink_message.decoded_payload.air_temperature)

temp_data.push({ 'air_temperature' : data.uplink_message.decoded_payload.air_temperature, 'date' : this.date_to_words(data.received_at) }  )

humidity_temp_data.push({ 'air_humidity' : data.uplink_message.decoded_payload.air_humidity, 'date' : this.date_to_words(data.received_at) }  )

pressure_temp_data.push({ 'air_pressure' : data.uplink_message.decoded_payload.barometric_pressure, 'date' : this.date_to_words(data.received_at) }  )

wind_temp_data.push({ 'wind' : data.uplink_message.decoded_payload.wind_speed, 'date' : this.date_to_words(data.received_at) }  )

light_temp_data.push({ 'light' : data.uplink_message.decoded_payload.light_intensity, 'date' : this.date_to_words(data.received_at) }  )


rain_temp_data.push({ 'rain' : data.uplink_message.decoded_payload.rain_accumulation, 'date' : this.date_to_words(data.received_at) }  )

uv_temp_data.push({ 'uv' : data.uplink_message.decoded_payload.uv_index, 'date' : this.date_to_words(data.received_at) }  )


}



}

})


this.filtered_data =  all_temp_data


/// air temperature

const averagesByDate = temp_data.reduce((acc, { air_temperature, date }) => {
  if (!acc[date]) {
    acc[date] = { total: 0, count: 0 };
  }
  if(air_temperature>0){
    acc[date].total += air_temperature;
  }
  acc[date].count += 1;
  return acc;
}, {});

// Now compute the average per date
const result = Object.entries(averagesByDate).map(([date, { total, count }]) => ({
  date,
  average_temperature:  parseFloat((total / count).toFixed(2))
}));


var renamed = result.map(({ average_temperature, date }) => ({
  y : average_temperature,
  label : date
}));

 
 renamed = renamed.filter(item => item.y > 0);


this.options = {
        animationEnabled: true,
        title:{
      text: ""
        },
        data: [{
          type: "column",
          dataPoints: renamed
        }]
      }

/// air temperature



/// air humidity

const average_humidity_dates = humidity_temp_data.reduce((acc, { air_humidity, date }) => {
  if (!acc[date]) {
    acc[date] = { total: 0, count: 0 };
  }
  if(air_humidity>0){
    acc[date].total += air_humidity;
  }
  acc[date].count += 1;
  return acc;
}, {});

// Now compute the average per date
const humidity_result = Object.entries(average_humidity_dates).map(([date, { total, count }]) => ({
  date,
  average_humidity:  parseFloat((total / count).toFixed(2))
}));


var humidity_renamed = humidity_result.map(({ average_humidity, date }) => ({
  y : average_humidity,
  label : date
}));

 
 humidity_renamed = humidity_renamed.filter(item => item.y > 0);


this.humidity_data = {
        animationEnabled: true,
        title:{
      text: ""
        },
        data: [{
          type: "line",
          dataPoints: humidity_renamed
        }]
      }

/// air humidity









/// air pressure

const average_pressure_dates = pressure_temp_data.reduce((acc, { air_pressure, date }) => {
  if (!acc[date]) {
    acc[date] = { total: 0, count: 0 };
  }
  if(air_pressure>0){
    acc[date].total += air_pressure;
  }
  acc[date].count += 1;
  return acc;
}, {});

// Now compute the average per date
const pressure_result = Object.entries(average_pressure_dates).map(([date, { total, count }]) => ({
  date,
  average_pressure:  parseFloat((total / count).toFixed(2))
}));


var pressure_renamed = pressure_result.map(({ average_pressure, date }) => ({
  y : average_pressure,
  label : date
}));

 
 pressure_renamed = pressure_renamed.filter(item => item.y > 0);


this.pressure_data = {
        animationEnabled: true,
        title:{
      text: ""
        },
        data: [{
          type: "spline",
          dataPoints: pressure_renamed
        }]
      }

/// air pressure










/// wind

const average_wind_dates = wind_temp_data.reduce((acc, { wind, date }) => {
  if (!acc[date]) {
    acc[date] = { total: 0, count: 0 };
  }
  if(wind>0){
    acc[date].total += wind;
  }
  acc[date].count += 1;
  return acc;
}, {});

// Now compute the average per date
const wind_result = Object.entries(average_wind_dates).map(([date, { total, count }]) => ({
  date,
  average_wind:  parseFloat((total / count).toFixed(2))
}));


var wind_renamed = wind_result.map(({ average_wind, date }) => ({
  y : average_wind,
  label : date
}));

 
 wind_renamed = wind_renamed.filter(item => item.y > 0);


this.wind_data = {
        animationEnabled: true,
        title:{
      text: ""
        },
        data: [{
          type: "line",
          dataPoints: wind_renamed
        }]
      }

/// wind




/// light

const average_light_dates = light_temp_data.reduce((acc, { light, date }) => {
  if (!acc[date]) {
    acc[date] = { total: 0, count: 0 };
  }
  if(light>0){
    acc[date].total += light;
  }
  acc[date].count += 1;
  return acc;
}, {});

// Now compute the average per date
const light_result = Object.entries(average_light_dates).map(([date, { total, count }]) => ({
  date,
  average_light:  parseFloat((total / count).toFixed(2))
}));


var light_renamed = light_result.map(({ average_light, date }) => ({
  y : average_light,
  label : date
}));

 
 light_renamed = light_renamed.filter(item => item.y > 0);


this.light_data = {
        animationEnabled: true,
        title:{
      text: ""
        },
        data: [{
          type: "column",
          dataPoints: light_renamed
        }]
      }

/// light



      /// rain

const average_rain_dates = rain_temp_data.reduce((acc, { rain, date }) => {
  if (!acc[date]) {
    acc[date] = { total: 0, count: 0 };
  }
  if(rain>0){
    acc[date].total += rain;
  }
  acc[date].count += 1;
  return acc;
}, {});

// Now compute the average per date
const rain_result = Object.entries(average_rain_dates).map(([date, { total, count }]) => ({
  date,
  average_rain:  parseFloat((total / count).toFixed(2))
}));


var rain_renamed = rain_result.map(({ average_rain, date }) => ({
  y : average_rain,
  label : date
}));

 
 rain_renamed = rain_renamed.filter(item => item.y > 0);


this.rain_data = {
        animationEnabled: true,
        title:{
      text: ""
        },
        data: [{
          type: "line",
          dataPoints: rain_renamed
        }]
      }

/// rain






      /// uv index

const average_uv_dates = uv_temp_data.reduce((acc, { uv, date }) => {
  if (!acc[date]) {
    acc[date] = { total: 0, count: 0 };
  }
  if(uv>0){
    acc[date].total += uv;
  }
  acc[date].count += 1;
  return acc;
}, {});

// Now compute the average per date
const uv_result = Object.entries(average_uv_dates).map(([date, { total, count }]) => ({
  date,
  average_uv:  parseFloat((total / count).toFixed(2))
}));


var uv_renamed = uv_result.map(({ average_uv, date }) => ({
  y : average_uv,
  label : date
}));

 
 uv_renamed = uv_renamed.filter(item => item.y > 0);


this.uv_data = {
        animationEnabled: true,
        title:{
      text: ""
        },
        data: [{
          type: "spline",
          dataPoints: uv_renamed
        }]
      }

/// uv index




this.show_spinner = false




}catch (error) {
console.log(error)
}

}


},

created(){

this.filter_month = this.current_month()

this.get_data()

setTimeout((data)=>{
this.get_data()
}, 600000)


}


}

</script>




